import styled from 'styled-components'

const SmallTitle = styled.h6`
   font-size: 2.4rem;
   font-weight: 300;
`
export default SmallTitle
